import { css } from '@emotion/react';
import { widgetStyles } from '@sitebuilder/common';

const riskIndicatorStyles = css`
    margin-bottom: 1em;
    font-size: ${widgetStyles.themeVars['$font-size-regular']};

    .row {
        display: flex;
        width: 100%;
        margin: 0px;
    }

    .tile {
        width: 20%;
        position: relative;
        padding: 2px;
    }

    .label {
        text-align: center;
    }

    .shape {
        visibility: hidden;

        &.selected {
            visibility: visible;
        }
    }
`;

export const themeRiskIndicatorStyles = css`
    margin: 1em;

    .row {
        display: flex;
        width: 100%;
    }

    .tile {
        width: 20%;
        position: relative;
        padding: 2px;
    }

    .label {
        text-align: center;
    }

    .shape {
        visibility: hidden;

        &.selected {
            visibility: visible;
        }
    }

    .risk-rating {
        font-size: 12px;
        color: var(--color-black);
    }

    .cell-1 {
        background-color: var(--color-risk-indicator-tile-1);
        -webkit-clip-path: polygon(0% 75%, 100% 60%, 100% 100%, 0% 100%);
    }

    .cell-2 {
        background-color: var(--color-risk-indicator-tile-2);
        -webkit-clip-path: polygon(0% 60%, 100% 45%, 100% 100%, 0% 100%);
    }

    .cell-3 {
        background-color: var(--color-risk-indicator-tile-3);
        -webkit-clip-path: polygon(0% 45%, 100% 30%, 100% 100%, 0% 100%);
    }

    .cell-4 {
        background-color: var(--color-risk-indicator-tile-4);
        -webkit-clip-path: polygon(0% 30%, 100% 15%, 100% 100%, 0% 100%);
    }

    .cell-5 {
        background-color: var(--color-risk-indicator-tile-5);
        -webkit-clip-path: polygon(0% 15%, 100% 0%, 100% 100%, 0% 100%);
    }

    .shape {
        position: absolute;
        left: 40%;
        border: 5px solid transparent;
        border-top: 5px solid var(--color-black);
    }

    .shape-1 {
        top: 30%;
    }

    .shape-2 {
        top: 0;
    }

    .shape-3 {
        top: 12%;
    }

    .shape-5 {
        top: -8%;
    }

    .tile {
        .scale-cell {
            height: 20px;
        }
        .label {
            font-size: 11px;
            color: var(--color-black);
        }
    }

    .chart-container {
        position: relative;
        width: 100px;

        .chart-risk-rating {
            position: absolute;
            top: 80%;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            color: var(--default-text-color);
        }
    }

    .risk-image-container {
        .risk-image {
            width: 100px;
            height: 100px;
        }
    }

    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }
`;

/*
Apply these styles to override the above styles and to get different risk indicator model

.scale-cell {
    height: 40px;
    background-color: "#aeb0b3";

    &.selected {
        background-color: "#000";
    }
}

.scale-cell {
    height: 10px;
}
.shape {
    position: absolute;
    left: 40%;
    border: 8px solid transparent;
    border-top: 8px solid white;
}

svg paths for signal type risk indicator

const pathStrings = [
    'M0,37.5 50,30 50,50 0,50z',
    'M0,30 50,22.5 50,50 0,50z',
    'M0,22.5 50,15 50,50 0,50z',
    'M0,15 50,7.5 50,50 0,50z',
    'M0,7.5 50,0 50,50 0,50z',
];

*/

export default riskIndicatorStyles;
